import { GameId } from '@bg-shared/enums';
import { getMatchedGameId } from './getMatchedGameId';

export const isGameActive = (gameID: GameId) =>
    getMatchedGameId(window.location.pathname) === gameID;
